import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";

export const ReturnDropOff = ({ returnOrder }) => {
  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Drop Off Details
      </Typography>
      <Stack direction="row" spacing={2}>
        <TextField
          size="small"
          fullWidth
          id={`drop-off-email`}
          label="Email"
          value={returnOrder.dropEmail}
          slotProps={{
            input: {
              readOnly: true,
            },
          }}
        />
        <TextField
          size="small"
          fullWidth
          id={`drop-off-postcode`}
          label="Postcode"
          value={returnOrder.dropPostcode}
          slotProps={{
            input: {
              readOnly: true,
            },
          }}
        />
      </Stack>
    </Paper>
  );
};
